import { removeProtocol } from '../../shared/utils';
import { VIRTUAL_AGENCY_URL } from './urls';

export const MINIMUM_PENSION_ESTIMATE_STEP_TITLE = 'Conoce la estimación de la pensión mínima objetivo';
export const MINIMUM_PENSION_ESTIMATE_STEP_DESCRIPTION = `
A continuación, te mostramos <strong>el saldo que necesitas acumular en tu cuenta</strong>
cuando cumplas la edad de jubilación (65 años). Si deseas <strong>recibir una pensión mayor</strong>, indica cuál es tu pensión deseada.
`;
export const MINIMUM_PENSION_ESTIMATE_ALERT_TEXT = (processStartDate) => `
Si deseas optar por la pensión mínima objetivo, a partir del ${processStartDate} puedes ingresar una solicitud de acogimiento en
<a href="${ VIRTUAL_AGENCY_URL }" target="_blank" rel="noopener noreferrer">${ removeProtocol(VIRTUAL_AGENCY_URL) }</a>
`

export const MINIMUM_PENSION_ESTIMATE_DESIRED_PENSION_TITLE = '¿Quieres una pensión mayor?';

export const MINIMUM_PENSION_ESTIMATE_CARD_TWO_DESIRED_PENSION = (desiredPensionAmounts = {}) => ([
  {
    concept: 'Este es el saldo que necesitas',
    amount: desiredPensionAmounts?.amountPensionDesiredBalance
  },
]);

export const MINIMUM_PENSION_ESTIMATE_INPUT_LABEL = 'Ingresa el monto que deseas recibir al jubilarte';

export const MINIMUM_PENSION_ESTIMATE_TOOLTIP_PROPS = {
  title: 'Tu pensión mínima objetivo puede variar',
  description: 'Si se producen cambios en el valor de la Canasta Básica de Consumo (CBC), fijada por el INEI.',
}